module.exports = __webpack_public_path__ + "static/img/cheer2.5eaaa88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/cheer/cheer2.jpg
// module id = H3Z7
// module chunks = 1